
import { useEvents } from "@shapeable/ui";
import { transformEvent } from "../utils/transforms";
import { isWorkshopEvent } from "../types";
export const useWorkshops = () => (useEvents().filter(isWorkshopEvent).map(transformEvent));